<section class="services-card voice-card">
  <div *ngIf="!isPlaying && !isRecording && !end" class="voice-idle">
    <div class="voice-idle__info">
      <ion-icon name="mic-outline"></ion-icon>
      <span>{{ "UX_TEXT.DEMANDE.VOICE.MESSAGE" | translate }}</span>
      <small>({{ "UX_TEXT.DEMANDE.COMMON.OPTIONAL" | translate }})</small>
    </div>
    <button type="button" class="voice-idle__btn" (click)="toggle.emit()">
      <ion-icon name="mic"></ion-icon>
    </button>
  </div>

  <div *ngIf="isRecording && !end" class="voice-recording">
    <span class="voice-recording__dot"></span>
    <span class="voice-recording__label">{{ "UX_TEXT.DEMANDE.VOICE.RECORDING" | translate }}</span>
    <div class="voice-recording__progress">
      <div class="voice-recording__bar" [style.width.%]="recordingProgressPercent"></div>
    </div>
    <span class="voice-recording__time">{{ recordingClock }}</span>
    <button type="button" class="voice-recording__stop" (click)="toggle.emit()">
      <ion-icon name="stop"></ion-icon>
    </button>
  </div>

  <div *ngIf="!isRecording && end" class="voice-recorded">
    <button type="button" class="voice-recorded__play" (click)="toggle.emit()">
      <ion-icon [name]="isPlaying && !inPause ? 'pause' : 'play'"></ion-icon>
    </button>
    <div class="voice-recorded__progress">
      <div class="voice-recorded__bar" [style.width.%]="playbackProgressPercent"></div>
    </div>
    <span class="voice-recorded__time">{{ playbackClock }}</span>
    <button type="button" class="voice-recorded__delete" (click)="remove.emit()">
      <ion-icon name="trash-outline"></ion-icon>
    </button>
  </div>
</section>
